import { angular, app } from '../../app.module'
/**
 * DialogService ダイアログ表示用のサービス
 * @param  {Function} $mdDialog ダイアログ表示用
 * @param  {Function} $mdToast Toast表示用
 * @return {Object} ダイアログ表示用のサービスを格納したオブジェクト
 */
function DialogService($mdDialog, $mdToast) {
  /**
   * showError エラーを表示するダイアログ
   * @param {String} errTitle エラーのタイトル
   * @param {String} errMessage エラーの内容
   * @return {void}
   */
  function showError(errTitle, errMessage) {
    $mdDialog.show(
      $mdDialog
        .alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .title(errTitle)
        .textContent(errMessage)
        .ok('閉じる')
    )
  }

  /**
   * showToast エラーを表示するtoast
   * @param {String} message メッセージ
   * @param {String} toastType toastのタイプ($mdThemingProviderでセットされている値を指定)
   * @return {void}
   */
  function showToast(message, toastType) {
    $mdToast.show(
      $mdToast.simple().textContent(message).theme(toastType).position('top right').hideDelay(3000)
    )
  }

  return {
    // エラーを表示するダイアログ
    showError: showError,
    showToast: showToast,
  }
}

// ダイアログ表示用のサービスを定義
app.factory('DialogService', DialogService)
